import {
  GET_COMMUNICATION_SETTINGS_REQUEST,
  GET_COMMUNICATION_SETTINGS_SUCCESS,
  GET_COMMUNICATION_SETTINGS_FAILURE,

  GET_DISPLAY_COMMUNICATION_SETTINGS_REQUEST,
  GET_DISPLAY_COMMUNICATION_SETTINGS_SUCCESS,
  GET_DISPLAY_COMMUNICATION_SETTINGS_FAILURE,

  UPDATE_COMMUNICATION_SETTINGS_REQUEST,
  UPDATE_COMMUNICATION_SETTINGS_SUCCESS,
  UPDATE_COMMUNICATION_SETTINGS_FAILURE,
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: false,
  error: null,
  isFetched: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_COMMUNICATION_SETTINGS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_COMMUNICATION_SETTINGS_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null, isFetched: true, };
    case GET_COMMUNICATION_SETTINGS_FAILURE:
      return { ...state, isLoading: false, error: action.payload, isFetched: true, };

    case GET_DISPLAY_COMMUNICATION_SETTINGS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_DISPLAY_COMMUNICATION_SETTINGS_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null, isFetched: true, };
    case GET_DISPLAY_COMMUNICATION_SETTINGS_FAILURE:
      return { ...state, isLoading: false, error: action.payload, isFetched: true, };

    case UPDATE_COMMUNICATION_SETTINGS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case UPDATE_COMMUNICATION_SETTINGS_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case UPDATE_COMMUNICATION_SETTINGS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
